import { useTranslation } from 'react-i18next';

/** Muted "approx." shown after a distance that is only an estimate (not a road route). */
export function ApproxMarker({ estimated }: { estimated: boolean | null | undefined }) {
  const { t } = useTranslation();
  if (estimated !== true) return null;
  return (
    <span
      data-testid="distance-approx"
      style={{ marginLeft: 4, color: 'var(--muted)', fontWeight: 400, fontStyle: 'italic' }}
    >
      {t('shipments.approxMarker.approx')}
    </span>
  );
}
